import React from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from '../Base';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
  space: {
    display: 'block',
    marginTop: 16,
  }
}))


function GoalDisallowedEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const period = periods[event.period].name;
  const scorer = players[event.player];
  const team = teams[scorer.team].id;
  const deflector = event.deflect && players[event.deflect.player];
  
  return (
    <Base
      time={event.second}
      period={period}
      team={team}
      type="GOAL DISALLOWED"
    >
      <Typography variant="body2">
        Goal scored by{' '}
        <span className={classes.bold}>{scorer.name}</span>
        { deflector && (
          <>
            {' '} on a deflection by {' '}
            <span className={classes.bold}>{deflector.name}</span>
          </>
        )}
        .{' '}
        <span className={clsx(classes.bold, classes.space)}>After further review, the goal has been CALLED BACK.</span>
      </Typography>
    </Base>
  )
}

export default GoalDisallowedEvent;
